<template>
  <v-col class="d-flex justify-start">
        <v-btn v-if="False"  class="mr-4 gris_medio" @click="sendNom">
          <v-icon left>mdi-upload</v-icon>
          {{$t('resultados.nominacion')}}
        </v-btn>
        <v-btn  class="mr-4 gris_medio" @click="sendMailNom">
          <v-icon left>mdi-email</v-icon>
          {{$t('resultados.mail_nom')}}
        </v-btn>
        <v-btn  class="mr-4 gris_medio" @click="sendMailPlan">
          <v-icon left>mdi-email</v-icon>
          {{$t('resultados.mail_planificacion')}}
        </v-btn>

        <v-btn  class="mr-4 gris_medio" @click="printView">
          <v-icon left>mdi-printer</v-icon>
          {{$t('resultados.imprimir')}}
        </v-btn>

        <v-btn  class="mr-4 gris_medio" @click="exportToExcel">
          <v-icon left>mdi-file-excel</v-icon>
          {{$t('resultados.descargar_excel')}}
        </v-btn>
        <v-btn class="mr-4 gris_medio" @click="$emit('descargar-excel')" v-if="!vista_operador">
          <v-icon left>mdi-file-excel</v-icon>
          {{$t('resultados.descargar_excel_completo')}}
        </v-btn> </v-col>
        <v-col>
        <v-btn class="mr-4 gris_medio" @click="exportOfertaSecundariaExcel">
          <v-icon left>mdi-file-excel</v-icon>
          {{$t('resultados.descargar_excel_oferta_secundaria')}}
        </v-btn>
        <v-btn class="mr-4 gris_medio" @click="exportOfertaMercadoIntradiarioExcel">
          <v-icon left>mdi-file-excel</v-icon>
          {{$t('resultados.descargar_excel_intradiario')}}
        </v-btn>
    </v-col>
  <div class="box">
    
    <div id="printable-content">
    <v-row>
      <v-table class="row-height-50">
        <thead>
          <tr>
            <th>{{$t('resultados.motor')}}</th>
            <th v-for="hora in horasUnicas_motores" :key="hora">{{ hora }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="concepto in datosTranspuestos_motores" :key="concepto.nombre" >
            <!-- Fila del motor -->
            <tr>
              <td class="motor">{{ concepto.nombre }}</td>
              <td
                v-for="hora in horasUnicas_motores"
                :key="hora"
                :style="getColorCell(concepto.valores[hora])"
                class="hora-col"
              >
              </td>
            </tr>

            <!-- Fila de hueco después de Motor 4 y Motor 6 -->
            <tr
              v-if="concepto.nombre === 'Motor 4' || concepto.nombre === 'Motor 6'"
            >
              <td :colspan="horasUnicas_motores.length + 1" style="height: 10px;"></td>
            </tr>
          </template>
        </tbody>
      </v-table>
    </v-row>
  

    <br /><br />

    <v-row>
      <v-table class="row-height-50">
        <thead>
          <tr>
            <th>{{$t('resultados.calderas')}}</th>
            <th v-for="hora in horasUnicas_calderas" :key="hora">{{ hora }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="concepto in datosTranspuestos_calderas" :key="concepto.nombre">
            <td class="caldera"> {{
              concepto.nombre === 'Caldera 1'
                ? 'Caldera eléctrica 11'
                : concepto.nombre === 'Caldera 2'
                ? 'Caldera eléctrica 12'
                : concepto.nombre
            }}
            </td>
            <td v-for="hora in horasUnicas_calderas" :key="hora" :style="getColorCell(concepto.valores[hora])" class="hora-col">
              <!--{{ concepto.valores[hora] ?? '-' }}-->
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-row>

    <br /><br />

    <v-row>
      <v-table class="row-height-50">
        <thead>
          <tr>
            <th></th>
            <th v-for="hora in horasUnicas_conceptos" :key="hora" class="H">{{ hora }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="concepto in datosTranspuestos_conceptos" :key="concepto.nombre">
            <td class="columna-fija">{{ concepto.nombre }}</td>
            <td v-for="hora in horasUnicas_conceptos" :key="hora" class="hora-col">
              {{ concepto.valores[hora] ?? "-" }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-row>


    <br /><br />
    <v-row>
      <v-table class="row-height-50">
        <thead>
          <tr>
            <th></th>
            <th v-for="hora in horasUnicas_horario_general" :key="hora" class="H">{{ hora }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="concepto in datosTranspuestos_conceptos_motores_horario" :key="concepto.nombre">
            <td class="columna-fija">{{ concepto.nombre }}</td>
            <td v-for="hora in horasUnicas_horario_general" :key="hora" class="hora-col">
              {{ concepto.valores[hora]?.toFixed(2) ?? "-" }}
            </td>
          </tr>
          <tr v-for="concepto in datosTranspuestos_conceptos_calderas_horario" :key="concepto.nombre">
            <td class="columna-fija">{{ concepto.nombre }}</td>
            <td v-for="hora in horasUnicas_horario_general" :key="hora" class="hora-col">
              {{ concepto.valores[hora]?.toFixed(2) ?? "-" }}
            </td>
          </tr>
          
        </tbody>
      </v-table>
    </v-row>

<br /><br />
    
     <v-row v-if="!esPlanificacion && datosTranspuestos_programa_qh.length">
        <v-table class="row-height-50">
          <thead>
            <tr>
              <th></th>
              <th 
                v-for="hora in horasUnicas_programa_qh" 
                :key="hora" 
                class="H"
              >
                {{ hora }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr 
              v-for="concepto in datosTranspuestos_programa_qh" 
              :key="concepto.nombre"
            >
              <td class="columna-fija">{{ concepto.nombre }}</td>

              <td 
                v-for="hora in horasUnicas_programa_qh" 
                :key="hora" 
                class="hora-col"
              >
                {{ concepto.valores[hora] != null ? Number(concepto.valores[hora]).toFixed(2) : "-" }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-row>
   
    

    


  </div>

     <!-- Botones para imprimir y exportar -->
    <v-row class="mt-8 justify-center">
      <v-col cols="4">
        <v-card class="pa-4 text-center stat-card">
          <v-card-title class="text-h4 font-weight-bold">
            {{ items['total_consumo_gas'] }} MWh
          </v-card-title>
          <v-card-subtitle class="text-subtitle-1">
            {{$t('resultados.consumo_gas_total')}}
          </v-card-subtitle>
        </v-card>
      </v-col>
     <!-- </v-row>
      <v-row class="mt-8 justify-center"> -->
      <v-col cols="4">
        <v-card class="pa-4 text-center">
          <v-card-title class="text-h4 font-weight-bold">
            {{ precioPoolRef != null ? precioPoolRef.toFixed(2) : '-' }}  EUR/MWh
          </v-card-title>
          <v-card-subtitle class="text-subtitle-1">
           {{$t('resultados.precio_pool')}}
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="pa-4 text-center">
          <v-card-title class="text-h4 font-weight-bold">
            {{ precioPoolRefCe != null ? precioPoolRefCe.toFixed(2) : '-' }}  EUR/MWh
          </v-card-title>
          <v-card-subtitle class="text-subtitle-1">
            {{$t('resultados.precio_pool_ce')}}
        </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      
    </v-row>


  </div>
</template>

<script>
//import * as XLSX from "xlsx";
//import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from "exceljs";

import JSZip from 'jszip';
import axios from 'axios';
import store from '../../store';
import { saveAs } from "file-saver";
//import logoExcel from "@/assets/ignis.png";
import Swal from "sweetalert2";

export default {
  props: {
  items: Object,
  fechaActual: {
    type: String,
    required: true,
  },
  vista_operador: {
    type: Boolean,
    default: false
  },
  modoEjecucion: {
    type: String,
    required: true,
  },
  precioPoolReferencia: {
    type: [Number, String],
    default: null
  },
  precioPoolReferenciaCe: {
    type: [Number, String],
    default: null
  },

    precios_omie: {
    type: Array,
    default: () => []
  },
    precios_omie_qh: {
    type: Array,
    default: () => []
  },

   parametrosGas: {
    type: Object,
    default: () => ({})
  },
  otros: {
  type: Object,
  default: () => ({})
}
},
  emits: ['descargar-excel'],

  data() {
    return {
      datosApi: [],
      fechaSimulacion:"",
      fecha:"",
      
    };
  },

  computed: {
    esPlanificacion() {
  return Number(this.modoEjecucion) === 4 || this.modoEjecucion === "Planificación";
},

datosProgramaQhFuente() {
  // Prioridad 1: nueva salida real sal_opqh.dat procesada por backend
  if (Array.isArray(this.items?.programa_qh) && this.items.programa_qh.length) {
    return this.items.programa_qh;
  }

  // Fallback temporal: datos antiguos
  return this.items?.conceptos_programas || [];
},

horasUnicas_programa_qh() {
  const datos = this.datosProgramaQhFuente;

  return [...new Set(datos.map(d => d.hora))]
    .sort((a, b) => {
      const parseHoraQh = (h) => {
        const texto = String(h || "");

        const matchQh = texto.match(/H\s*0*([0-9]+)\.([0-9]+)/i);
        if (matchQh) {
          const hora = Number(matchQh[1]);
          const cuarto = Number(matchQh[2]);
          return (hora - 1) * 4 + cuarto;
        }

        const matchH = texto.match(/H\s*0*([0-9]+)/i);
        if (matchH) {
          const hora = Number(matchH[1]);
          return (hora - 1) * 4 + 1;
        }

        return 0;
      };

      return parseHoraQh(a) - parseHoraQh(b);
    });
},

datosTranspuestos_programa_qh() {
  const datos = this.datosProgramaQhFuente.filter(
    d => String(d.concepto || "").trim().toLowerCase() === "programa motores"
  );

  const agrupados = {};

  datos.forEach(({ concepto, hora, valor }) => {
    if (!agrupados[concepto]) {
      agrupados[concepto] = {
        nombre: concepto,
        valores: {}
      };
    }

    agrupados[concepto].valores[hora] = valor;
  });

  return Object.values(agrupados);
},
    horasUnicas_motores() {
      return [...new Set(this.items.motores.map((d) => d.hora))]
        .sort((a, b) => {
          const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
          const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
          return numA - numB;
        });
    },
    datosTranspuestos_motores() {
      const agrupados = {};
      this.items.motores.forEach(({ concepto, hora, valor }) => {
        if (!agrupados[concepto]) {
          agrupados[concepto] = { nombre: concepto, valores: {} };
        }
        agrupados[concepto].valores[hora] = valor;
      });
      return Object.values(agrupados);
    },

    horasUnicas_calderas() {
      return [...new Set(this.items.calderas.map((d) => d.hora))]
        .sort((a, b) => {
          const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
          const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
          return numA - numB;
        });
    },
    datosTranspuestos_calderas() {
      const agrupados = {};
      this.items.calderas.forEach(({ concepto, hora, valor }) => {
        if (!agrupados[concepto]) {
          agrupados[concepto] = { nombre: concepto, valores: {} };
        }
        agrupados[concepto].valores[hora] = valor;
      });
      return Object.values(agrupados);
    },

    horasUnicas_conceptos() {
      return [...new Set(this.items.conceptos.map((d) => d.hora))]
        .sort((a, b) => {
          const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
          const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
          return numA - numB;
        });
    },
    datosTranspuestos_conceptos() {
      const agrupados = {};
      this.items.conceptos.forEach(({ concepto, hora, valor }) => {
        if (!agrupados[concepto]) {
          agrupados[concepto] = { nombre: concepto, valores: {} };
        }
        agrupados[concepto].valores[hora] = valor;
      });
      return Object.values(agrupados);
    },

    
    datosTranspuestos_conceptos_calderas_horario() {
      const datosConvertidos = this.convertirConceptosACabecerasHorarias(
        this.items.conceptos_programas.filter(d => d.concepto === "Programa calderas eléctricas")
      );

      const agrupados = {};
      datosConvertidos.forEach(({ concepto, hora, valor }) => {
        if (!agrupados[concepto]) {
          agrupados[concepto] = { nombre: concepto, valores: {} };
        }
        agrupados[concepto].valores[hora] = valor;
      });

      return Object.values(agrupados);
    },
    horasUnicas_conceptos_prg() {
      return [...new Set(this.items.conceptos_programas.map((d) => d.hora))]
      .sort((a, b) => {
        const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
        const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
        return numA - numB;
      });
    },
    datosTranspuestos_conceptos_prg() {
      const datosFiltrados = this.items.conceptos_programas.filter(
        (d) => d.concepto === "Programa motores"
      );

      const agrupados = {};
      datosFiltrados.forEach(({ concepto, hora, valor }) => {
        if (!agrupados[concepto]) {
          agrupados[concepto] = { nombre: concepto, valores: {} };
        }
        agrupados[concepto].valores[hora] = valor;
      });

      return Object.values(agrupados);
    },
    
    datosTranspuestos_conceptos_motores_horario() {
      const datosConvertidos = this.convertirConceptosACabecerasHorarias(
        this.items.conceptos_programas.filter(d => d.concepto === "Programa motores")
      );

      const agrupados = {};
      datosConvertidos.forEach(({ concepto, hora, valor }) => {
        if (!agrupados[concepto]) {
          agrupados[concepto] = { nombre: concepto, valores: {} };
        }
        agrupados[concepto].valores[hora] = valor;
      });

      return Object.values(agrupados);
    },
    horasUnicas_horario_general() {
      const horasMotores = this.horasUnicas_conceptos_motores_horario;
      const horasCalderas = this.horasUnicas_conceptos_calderas_horario;
      return [...new Set([...horasMotores, ...horasCalderas])]
        .sort((a, b) => {
          const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
          const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
          return numA - numB;
        });
    },
    horasUnicas_conceptos_motores_horario() {
      const datosConvertidos = this.convertirConceptosACabecerasHorarias(
        this.items.conceptos_programas.filter(d => d.concepto === "Programa motores") ?? []
      );
      return [...new Set(datosConvertidos.map(d => d.hora))]
        .sort((a, b) => {
          const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
          const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
          return numA - numB;
        });
    },

    horasUnicas_conceptos_calderas_horario() {
      const datosConvertidos = this.convertirConceptosACabecerasHorarias(
        this.items.conceptos_programas.filter(d => d.concepto === "Programa calderas eléctricas") ?? []
      );
      return [...new Set(datosConvertidos.map(d => d.hora))]
        .sort((a, b) => {
          const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
          const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
          return numA - numB;
        });
    },
precioPoolRef() {
      const v = this.precioPoolReferencia;
      return v == null ? null : Number(v);
    },
precioPoolRefCe() {
      const v = this.precioPoolReferenciaCe;
      return v == null ? null : Number(v);
    },
  },
  


  methods: {
    convertirFechaExcel(valor) {
  if (!valor) return "";

  if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
    return valor;
  }

  const texto = String(valor).trim();

  const match = texto.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

  if (!match) return "";

  const dia = Number(match[1]);
  const mes = Number(match[2]);
  const anio = Number(match[3]);

  return new Date(anio, mes - 1, dia);
},
  normalizarNumeroExcelPunto(valor, decimales = 2) {
  if (valor === "" || valor == null || valor === "-") return "";

  let texto = String(valor).trim();

  if (texto === "") return "";

  // Quitar espacios normales y espacios raros de Excel
  texto = texto.replace(/\s/g, "").replace(/\u00A0/g, "");

  // Si viene en formato español: 1.234,56
  if (texto.includes(".") && texto.includes(",")) {
    texto = texto.replace(/\./g, "").replace(",", ".");
  } else {
    texto = texto.replace(",", ".");
  }

  const numero = Number(texto);

  if (!Number.isFinite(numero)) return "";

  return Number(numero.toFixed(decimales));
},
  normalizarNumeroExcel(valor, decimales = 2) {
  if (valor === "" || valor == null || valor === "-") return "";

  if (typeof valor === "number") {
    if (!Number.isFinite(valor)) return "";
    return Number(valor.toFixed(decimales));
  }

  let texto = String(valor).trim();

  if (texto === "" || texto === "-") return "";

  // Quita espacios normales y espacios raros de Excel
  texto = texto.replace(/\s/g, "").replace(/\u00A0/g, "");

  // Si viene de algún formateo anterior como "0," o "20,"
  texto = texto.replace(/[,.]$/, "");

  // Si trae unidades o letras, no lo convertimos
  if (/[a-zA-ZáéíóúÁÉÍÓÚñÑ€%]/.test(texto)) return "";

  // Formato español: "1.234,56"
  if (texto.includes(".") && texto.includes(",")) {
    texto = texto.replace(/\./g, "").replace(",", ".");
  }
  // Formato español simple: "12,34"
  else if (texto.includes(",")) {
    texto = texto.replace(",", ".");
  }
  // Formato miles español sin decimales: "1.234"
  else if (/^-?\d{1,3}(\.\d{3})+$/.test(texto)) {
    texto = texto.replace(/\./g, "");
  }

  const numero = Number(texto);

  if (!Number.isFinite(numero)) return "";

  return Number(numero.toFixed(decimales));
},

formatearNumeroES(valor, decimales = 2) {
  if (valor === "" || valor == null || valor === "-") return "-";

  const numero = Number(String(valor).replace(",", "."));

  if (!Number.isFinite(numero)) return valor;

  return numero.toLocaleString("es-ES", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales
  });
},
    extraerNumeroHora(hora) {
  const match = String(hora || "").match(/H\s*0*([0-9]+)/i);
  return match ? parseInt(match[1], 10) : null;
},
 expandirProgramaMotoresACuartos() {
  const normalizarTexto = (txt) =>
    String(txt || "").trim().toLowerCase();

  const datosProgramaMotores = (this.datosProgramaQhFuente || []).filter(
    d => normalizarTexto(d.concepto) === "programa motores"
  );

  if (!datosProgramaMotores.length) {
    console.warn("No se encontraron datos de 'Programa motores'");
    return Array(96).fill("");
  }

  const resultado = Array(96).fill("");

  datosProgramaMotores.forEach(({ hora, valor }) => {
    const texto = String(hora || "").trim();

    // Caso QH: H01.1, H01.2, H01.3, H01.4
    const matchQh = texto.match(/H\s*0*([0-9]+)\.([0-9]+)/i);
    if (matchQh) {
      const h = Number(matchQh[1]);
      const q = Number(matchQh[2]);

      if (h >= 1 && h <= 24 && q >= 1 && q <= 4) {
        const index = (h - 1) * 4 + (q - 1);
        resultado[index] = valor;
      }

      return;
    }

    // Caso horario: H01, H02... Se replica a los 4 cuartos
    const matchH = texto.match(/H\s*0*([0-9]+)/i);
    if (matchH) {
      const h = Number(matchH[1]);

      if (h >= 1 && h <= 24) {
        const index = (h - 1) * 4;
        resultado[index] = valor;
        resultado[index + 1] = valor;
        resultado[index + 2] = valor;
        resultado[index + 3] = valor;
      }
    }
  });

  console.log("Programa motores usado en oferta secundaria:", resultado);

  return resultado;
},
obtenerPrecioOmieCuartohorario() {
  const extraerPrecio = (registro) => {
    if (registro == null || typeof registro !== "object") return "";

    if (registro.precio != null) return Number(registro.precio);
    if (registro.valor != null) return Number(registro.valor);
    if (registro.price != null) return Number(registro.price);
    if (registro.PRECIO != null) return Number(registro.PRECIO);
    if (registro.Precio != null) return Number(registro.Precio);
    if (registro.VALOR != null) return Number(registro.VALOR);

    const clavePrecio = Object.keys(registro).find(k =>
      k.toLowerCase().includes("precio") ||
      k.toLowerCase().includes("price") ||
      k.toLowerCase().includes("valor")
    );

    return clavePrecio ? Number(registro[clavePrecio]) : "";
  };

  const extraerOrdenQH = (registro, index) => {
    if (registro.cuarto != null) return Number(registro.cuarto);
    if (registro.q != null) return Number(registro.q);
    if (registro.Q != null) return Number(registro.Q);
    if (registro.periodo != null) return Number(registro.periodo);
    if (registro.PERIODO != null) return Number(registro.PERIODO);

    if (registro.hora != null) {
      const texto = String(registro.hora).trim();

      // H01.1, H01.2, H01.3, H01.4
      const matchQH = texto.match(/H\s*0*([0-9]+)\.([0-9]+)/i);
      if (matchQH) {
        const hora = Number(matchQH[1]);
        const cuarto = Number(matchQH[2]);
        return (hora - 1) * 4 + cuarto;
      }

      // 01.1, 01.2, 01.3, 01.4
      const matchQHSinH = texto.match(/^0*([0-9]+)\.([0-9]+)$/);
      if (matchQHSinH) {
        const hora = Number(matchQHSinH[1]);
        const cuarto = Number(matchQHSinH[2]);
        return (hora - 1) * 4 + cuarto;
      }
    }

    // Si ya vienen 96 registros en orden, usamos el índice.
    return index + 1;
  };

  const extraerOrdenHoraria = (registro, index) => {
    if (registro.hora != null) {
      const texto = String(registro.hora).trim();

      // H01, H02, etc.
      const matchH = texto.match(/H\s*0*([0-9]+)/i);
      if (matchH) return Number(matchH[1]);

      // 1, 2, 3...24
      const matchNumero = texto.match(/^0*([0-9]+)$/);
      if (matchNumero) return Number(matchNumero[1]);
    }

    if (registro.periodo != null) return Number(registro.periodo);
    if (registro.PERIODO != null) return Number(registro.PERIODO);
    if (registro.h != null) return Number(registro.h);
    if (registro.H != null) return Number(registro.H);

    return index + 1;
  };

  const normalizarPrecios = (datos, extraerOrden) => {
    return datos
      .map((registro, index) => ({
        orden: extraerOrden(registro, index),
        precio: extraerPrecio(registro)
      }))
      .filter(d =>
        d.orden != null &&
        !Number.isNaN(Number(d.orden)) &&
        d.precio !== "" &&
        d.precio != null &&
        !Number.isNaN(Number(d.precio))
      )
      .sort((a, b) => Number(a.orden) - Number(b.orden))
      .map(d => Number(d.precio));
  };

  // 1. Primero intentamos usar precios cuartohorarios 
  const datosQH = Array.isArray(this.precios_omie_qh)
    ? this.precios_omie_qh
    : [];

  if (datosQH.length) {
    const preciosQH = normalizarPrecios(datosQH, extraerOrdenQH).slice(0, 96);

    console.log("Precios OMIE QH recibidos:", datosQH);
    console.log("Precios OMIE QH normalizados:", preciosQH);
    console.log("Número precios OMIE QH:", preciosQH.length);

    if (preciosQH.length === 96) {
      console.log("Usando precios OMIE QH reales");
      return preciosQH;
    }

    console.warn(
      `Hay precios OMIE QH, pero no son 96 válidos. Llegan ${preciosQH.length}. Se usarán horarios si existen.`
    );
  }

  // 2. Si no hay QH válidos, usamos horarios y los expandimos
  const datosHorarios = Array.isArray(this.precios_omie)
    ? this.precios_omie
    : [];

  if (!datosHorarios.length) {
    console.warn("No hay precios OMIE QH válidos ni precios OMIE horarios");
    return Array(96).fill("");
  }

  const preciosHorarios = normalizarPrecios(datosHorarios, extraerOrdenHoraria).slice(0, 24);

  console.log("Precios OMIE horarios recibidos:", datosHorarios);
  console.log("Precios OMIE horarios normalizados:", preciosHorarios);
  console.log("Número precios OMIE horarios:", preciosHorarios.length);

  if (preciosHorarios.length !== 24) {
    console.warn(
      `No hay 24 precios horarios válidos. Llegan ${preciosHorarios.length}.`
    );
    return Array(96).fill("");
  }

  console.log("Usando precios OMIE horarios y expandiendo cada hora a 4 cuartos");

  const resultado = [];
  preciosHorarios.forEach(p => {
    resultado.push(p, p, p, p);
  });

  return resultado;
},
async exportOfertaMercadoIntradiarioExcel() {
  try {
    this.loading = true;
    this.mensaje_loading = "Generando Excel de oferta intradiaria...";

    const programa = this.expandirProgramaMotoresACuartos();

    const payload = {
      fecha: this.fechaSimulacion,
      unidad_fisica: "UFVISCO",
      unidad_oferta: "IGVD174",
      unidad_programacion: "UPVISCO",
      sesion: 2,
      version: 1,
      potencia_max: this.normalizarNumeroExcelPunto(48.20, 2),
      programa: programa.map(valor =>
        valor !== "" && valor != null
          ? this.normalizarNumeroExcelPunto(valor, 2)
          : ""
      )
    };

    const response = await axios({
      method: "post",
      url: process.env.VUE_APP_API_BASE_URL + "/api/exportar-oferta-intradiario/",
      data: payload,
      responseType: "blob",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + store.state.token,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });

    const contentDisposition = response.headers["content-disposition"];
    let filename = "OMIESimple_QH_UFVISCO.xlsx";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }
    }

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, filename);

    this.loading = false;
  } catch (error) {
    console.error("Error al exportar oferta intradiaria:", error);
    this.loading = false;

    Swal.fire(
      "Error",
      "Hubo un problema al generar el Excel de oferta intradiaria.",
      "error"
    );
  }
},
  toNumero(valor, defecto = null) {
  const numero = Number(String(valor ?? "").replace(",", "."));
  return Number.isFinite(numero) ? numero : defecto;
},

obtenerDatosOfertaSecundaria() {
  const otros = this.otros || {};

  return {
    minTecnico: this.toNumero(otros.min_tecnico_secundaria, 16),
    cantidadMin: this.toNumero(otros.cantidad_min_secundaria, 12),
    cantidadMax: this.toNumero(otros.cantidad_max_secundaria, 47.4),
    costeOperativo: this.toNumero(otros.coste_operativo_secundaria, 95)
  };
},

generarDatosOfertaSecundaria() {
  const programa = this.expandirProgramaMotoresACuartos();
  const sec = this.obtenerDatosOfertaSecundaria();

  const subir = [];
  const bajar = [];
  const coste = [];

  for (let i = 0; i < 96; i++) {
    const potenciaLimiteSubir = this.toNumero(programa[i], null);

    if (potenciaLimiteSubir == null) {
      subir.push("");
      bajar.push("");
      coste.push(sec.costeOperativo);
      continue;
    }

    // Potencia límite a subir:
    // programa motores en cuarto horario
    const limiteSubir = potenciaLimiteSubir;

    // Potencia límite a bajar:
    // subir - banda, pero nunca por debajo del mínimo técnico
    const limiteBajarCalculado = limiteSubir - sec.cantidadMin;
    const limiteBajar = Math.max(sec.minTecnico, limiteBajarCalculado);

    subir.push(limiteSubir);
    bajar.push(limiteBajar);
    coste.push(sec.costeOperativo);
  }

  return { subir, bajar, coste };
},
   async exportOfertaSecundariaExcel() {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("data", {
  properties: {
    defaultRowHeight: 19.5
  }
});

  const borderAzul = {
    top: { style: "thin", color: { argb: "FF009999" } },
    left: { style: "thin", color: { argb: "FF009999" } },
    bottom: { style: "thin", color: { argb: "FF009999" } },
    right: { style: "thin", color: { argb: "FF009999" } }
  };

  const center = { vertical: "middle", horizontal: "center" };
  const right = { vertical: "middle", horizontal: "right" };
  const left = { vertical: "middle", horizontal: "left" };

  const fontArial11 = { name: "Arial", size: 11 };
  const fontCalibri10 = { name: "Calibri", size: 10 };
  const fontCalibri11 = { name: "Calibri", size: 11 };
  const fontAptos10Bold = { name: "Aptos", size: 10, bold: true };

  const blueFill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE3F8F5" }
  };

  const grayFill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFF2F2F2" }
  };

  const datos = this.generarDatosOfertaSecundaria();

  // CABECERA
  sheet.mergeCells("C4:H4");
  sheet.getCell("C4").value = "Formulario de intercambio de información";
  sheet.getCell("C4").font = {
    name: "Calibri",
    size: 14
  };
  sheet.getCell("C4").alignment = left;

  sheet.mergeCells("C5:J5");
  sheet.getCell("C5").value = "OFERTA PARA OPERATIVA DE SECUNDARIA";
  sheet.getCell("C5").font = {
    name: "Calibri",
    size: 24,
    color: { argb: "FF00A6A6" }
  };
  sheet.getCell("C5").alignment = left;

  sheet.mergeCells("C6:H6");
  sheet.getCell("C6").value = "Celdas modificables en color GRIS";
  sheet.getCell("C6").font = {
    name: "Calibri",
    size: 10,
    color: { argb: "FF000000" }
  };
  sheet.getCell("C6").alignment = left;

  // BLOQUE IZQUIERDO

  sheet.getCell("B9").value = "Unidad Física";
  sheet.getCell("B9").font = fontArial11;
  sheet.getCell("B9").alignment = right;

  sheet.getCell("C9").value = "UFVISCO";
  sheet.getCell("C9").font = fontArial11;
  sheet.getCell("C9").alignment = center;
  sheet.getCell("C9").fill = blueFill;
  sheet.getCell("C9").border = borderAzul;
  sheet.getCell("C9").numFmt = "0";

  sheet.getCell("B11").value = "Fecha";
  sheet.getCell("B11").font = fontArial11;
  sheet.getCell("B11").alignment = right;

  const fechaObj = this.convertirFechaExcel(this.fechaSimulacion);

  const fechaExcelSinHora = fechaObj
    ? Math.floor(
        (Date.UTC(fechaObj.getFullYear(), fechaObj.getMonth(), fechaObj.getDate()) -
          Date.UTC(1899, 11, 30)) /
          (24 * 60 * 60 * 1000)
      )
    : "";

  sheet.getCell("C11").value = fechaExcelSinHora;
  sheet.getCell("C11").font = fontCalibri11;
  sheet.getCell("C11").alignment = center;
  sheet.getCell("C11").fill = grayFill;
  sheet.getCell("C11").border = borderAzul;
  sheet.getCell("C11").numFmt = "dd/mm/yyyy";

  // POSICIONES
  const startCol = 4; // D
  const numQReales = 96;
  const numQTotales = 100;

  const filaHoras = 14;
  const filaCuartos = 15;
  const filaSubir = 16;
  const filaBajar = 17;
  const filaCoste = 18;

  // CABECERAS H y Q
let quarter = 1;

for (let h = 1; h <= 24; h++) {
  const colInicio = startCol + (h - 1) * 4;
  const colFin = colInicio + 3;

  sheet.mergeCells(filaHoras, colInicio, filaHoras, colFin);

  const horaCell = sheet.getCell(filaHoras, colInicio);
  horaCell.value = `H${h}`;
  horaCell.font = fontAptos10Bold;
  horaCell.alignment = center;
  horaCell.fill = blueFill;
  horaCell.border = borderAzul;

  for (let col = colInicio + 1; col <= colFin; col++) {
    const mergedCell = sheet.getCell(filaHoras, col);
    mergedCell.fill = blueFill;
    mergedCell.border = borderAzul;
  }

  for (let q = 0; q < 4; q++) {
    const cell = sheet.getCell(filaCuartos, colInicio + q);
    cell.value = `Q${quarter++}`;
    cell.font = fontAptos10Bold;
    cell.alignment = center;
    cell.fill = blueFill;
    cell.border = borderAzul;
  }
}

// H25* con Q97..Q100
const colInicioH25 = startCol + numQReales;
const colFinH25 = colInicioH25 + 3;

sheet.mergeCells(filaHoras, colInicioH25, filaHoras, colFinH25);

const h25Cell = sheet.getCell(filaHoras, colInicioH25);
h25Cell.value = "H25*";
h25Cell.font = fontAptos10Bold;
h25Cell.alignment = center;
h25Cell.fill = blueFill;
h25Cell.border = borderAzul;

for (let col = colInicioH25 + 1; col <= colFinH25; col++) {
  const mergedCell = sheet.getCell(filaHoras, col);
  mergedCell.fill = blueFill;
  mergedCell.border = borderAzul;
}

for (let q = 0; q < 4; q++) {
  const cell = sheet.getCell(filaCuartos, colInicioH25 + q);
  cell.value = `Q${numQReales + q + 1}`;
  cell.font = fontAptos10Bold;
  cell.alignment = center;
  cell.fill = blueFill;
  cell.border = borderAzul;
}

  // ETIQUETAS IZQUIERDA
  const etiquetas = [
    { row: filaSubir, label: "Potencia Límite a subir", unit: "MW" },
    { row: filaBajar, label: "Potencia Límite a bajar", unit: "MW" },
    { row: filaCoste, label: "Coste Operativo", unit: "€ / MWh" }
  ];

  etiquetas.forEach(({ row, label, unit }) => {
    const cellLabel = sheet.getCell(row, 2);
    const cellUnit = sheet.getCell(row, 3);

    cellLabel.value = label;
    cellUnit.value = unit;

    cellLabel.font = fontArial11;
    cellUnit.font = fontArial11;

    cellLabel.border = borderAzul;
    cellUnit.border = borderAzul;

    cellLabel.alignment = right;
    cellUnit.alignment = center;

    cellLabel.fill = blueFill;
    cellUnit.fill = blueFill;
  });

  // DATOS NUMÉRICOS
  for (let i = 0; i < numQTotales; i++) {
    const col = startCol + i;

    const c1 = sheet.getCell(filaSubir, col);
    c1.value = this.normalizarNumeroExcelPunto(datos.subir[i], 2);
    c1.font = fontCalibri10;
    c1.border = borderAzul;
    c1.alignment = center;
    c1.fill = grayFill;
    c1.numFmt = "0.00";

    const c2 = sheet.getCell(filaBajar, col);
    c2.value = this.normalizarNumeroExcelPunto(datos.bajar[i], 2);
    c2.font = fontCalibri10;
    c2.border = borderAzul;
    c2.alignment = center;
    c2.fill = grayFill;
    c2.numFmt = "0.00";

    const c3 = sheet.getCell(filaCoste, col);
    c3.value = this.normalizarNumeroExcelPunto(datos.coste[i], 2);
    c3.font = fontCalibri10;
    c3.border = borderAzul;
    c3.alignment = center;
    c3.fill = grayFill;
    c3.numFmt = "0.00";
  }

  // ANCHOS
  sheet.getColumn(2).width = 28;
  sheet.getColumn(3).width = 12;

  for (let col = startCol; col < startCol + numQTotales; col++) {
  sheet.getColumn(col).width = 8;
}

  // ALTURAS
  const alturas = {
    4: 23.3, // Formulario de intercambio de información
    5: 35.3, // OFERTA PARA OPERATIVA DE SECUNDARIA
    6: 19.5, // Celdas modificables en color GRIS
    9: 19.5, // Unidad Física
    11: 19.5, // Fecha
    [filaHoras]: 19.5,
    [filaCuartos]: 19.5,
    [filaSubir]: 19.5,
    [filaBajar]: 19.5,
    [filaCoste]: 19.5
  };

  Object.entries(alturas).forEach(([rowNumber, height]) => {
    const row = sheet.getRow(Number(rowNumber));
    row.height = height;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `Oferta_Secundaria_${this.fechaSimulacion}.xlsx`);
},
    agregarDatosAlWorkbook(sheet) {
      const azulClaro = 'FF9BC2E6';
      const bordeCompleto = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };

      const agregarTabla = (datos, headers, opciones = {}) => {
        const { renombrar, colorPorValor, blankAfter } = opciones;

        sheet.addRow([]);
        const filaHeader = sheet.addRow(["", ...headers]);
        filaHeader.font = { bold: true };
        filaHeader.eachCell(cell => {
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        datos.forEach((row) => {
          const nombre = renombrar ? renombrar(row.nombre) : row.nombre;
          const filaValores = [nombre];

          headers.forEach((hora) => {
            const valor = row.valores[hora];
            if (colorPorValor) {
              filaValores.push("");  // para pintar color
            } else {
              const valorFormateado = this.normalizarNumeroExcel(valor, 2);
              filaValores.push(valorFormateado !== "" ? valorFormateado : (valor ?? "-"));
            }
          });

          const fila = sheet.addRow(filaValores);

          fila.eachCell((cell, colNumber) => {
            if (colorPorValor && colNumber > 1 && row.valores[headers[colNumber - 2]]) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: azulClaro }
              };
            }

            if (colNumber === 1) {
              cell.border = bordeCompleto;
            }
            if (colNumber > 1 && cell.value !== "" && cell.value !== "-") {
                cell.numFmt = "@";
              }
            cell.alignment = { vertical: "middle", horizontal: "center" };
          });

          if (blankAfter && (row.nombre === "Motor 4" || row.nombre === "Motor 6")) {
            const filaBlanca = sheet.addRow(["", ...headers.map(() => "")]);
            filaBlanca.eachCell((cell, colNumber) => {
              if (colNumber === 1) {
                cell.border = bordeCompleto;
              }
            });
          }
        });
      };

      agregarTabla(this.datosTranspuestos_motores, this.horasUnicas_motores, {
        colorPorValor: true,
        blankAfter: true
      });

      agregarTabla(this.datosTranspuestos_calderas, this.horasUnicas_calderas, {
        colorPorValor: true,
        renombrar: (nombre) => {
          if (nombre.toLowerCase().includes("1")) return "Caldera eléctrica 11";
          if (nombre.toLowerCase().includes("2")) return "Caldera eléctrica 12";
          return nombre;
        }
      });

      agregarTabla(this.datosTranspuestos_conceptos, this.horasUnicas_conceptos);
      agregarTabla(
        [...this.datosTranspuestos_conceptos_motores_horario, ...this.datosTranspuestos_conceptos_calderas_horario],
        this.horasUnicas_horario_general
      );
     if (!this.esPlanificacion) {
      agregarTabla(
        this.datosTranspuestos_programa_qh,
        this.horasUnicas_programa_qh
      );
    }

      sheet.addRow([]);
      const filaTotal = sheet.addRow([
        "Consumo Total de Gas:",
        `${this.normalizarNumeroExcel(this.items.total_consumo_gas, 2)} MWh`
      ]);
      filaTotal.font = { bold: true };
      const filaPrecioPool = sheet.addRow([
        "Precio pool referencia motores de cogeneración:",
        this.precioPoolRef != null ? `${this.formatearNumeroES(this.precioPoolRef)} EUR/MWh` : "-"
      ]);
      filaPrecioPool.font = { bold: true };
      const filaPrecioPoolCe = sheet.addRow([
        "Precio pool referencia calderas eléctricas:",
        this.precioPoolRefCe != null ? `${this.formatearNumeroES(this.precioPoolRefCe)} EUR/MWh` : "-"
      ]);
      filaPrecioPoolCe.font = { bold: true };


      sheet.columns.forEach(col => { col.width = 12 });
      sheet.getColumn(1).width = 25;
    },

    getColorCell(value) {
      return value > 0 ? { backgroundColor: "#9bc2e6" } : {};
    },
    convertirConceptosACabecerasHorarias(datosCuartoHorario) {
      const agrupados = {};

      datosCuartoHorario.forEach(({ concepto, hora, valor }) => {
        // hora viene como "H01.2", queremos convertir a "H01"
        const horaHorario = hora.split(".")[0];
        const key = `${concepto}-${horaHorario}`;

        if (!agrupados[key]) {
          agrupados[key] = {
            concepto: concepto,
            hora: horaHorario,
            valores: []
          };
        }

        agrupados[key].valores.push(valor);
      });

      const resultado = [];
      Object.values(agrupados).forEach(({ concepto, hora, valores }) => {
        const promedio = valores.reduce((a, b) => a + b, 0) / valores.length;
        resultado.push({ concepto, hora, valor: promedio });
      });

      return resultado;
    },

    async printView() {
      const doc = new jsPDF("l", "mm", "a3"); 
      const estilosFilasBlancas = [];
      const margin = 10; 

      const fechaSimulacion=this.fechaSimulacion
        doc.text(`Planificación del día ${fechaSimulacion}`, 14, 15);

      const addTable = (headers, data, startY, hideValues = false) => {
          doc.autoTable({
              head: [headers],
              body: data,
              startY: startY,
              styles: { fontSize: 8, cellPadding: 1, overflow: "linebreak" },
              columnStyles: { 0: { cellWidth: 40 } },
              margin: { left: 10, right: 10 },
              didParseCell: function (data) {
                const isEmptyRow = estilosFilasBlancas.includes(data.row.index);
                
                if (isEmptyRow) {
                  data.cell.styles.fillColor = [255, 255, 255]; // blanco
                  data.cell.text = [""];
                  return;
                }

                if (hideValues && data.section === 'body' && data.column.index !== 0) {
                  const cellValue = parseFloat(data.cell.raw);
                  if (!isNaN(cellValue) && cellValue !== 0) {
                    data.cell.styles.fillColor = [155, 194, 230]; // Azul claro
                    data.cell.text = [" "];
                  } else if (cellValue === 0) {
                    data.cell.styles.fillColor = [255, 255, 255];
                    data.cell.text = [" "];
                  }
                }
              }
          });

          return doc.lastAutoTable.finalY + 10;
      };

      let startY = 20;

      // Generar las tablas 
      const tables = [
      {
        key: "motores",
        label: "Motor",
        data: this.datosTranspuestos_motores,
        headers: this.horasUnicas_motores,
        hideValues: true
      },
      {
        key: "calderas",
        label: "Calderas eléctricas",
        data: this.datosTranspuestos_calderas,
        headers: this.horasUnicas_calderas,
        hideValues: true
      }
    ];

      tables.forEach((table) => {
        const headers = [table.label, ...table.headers];
        const data = [];

          table.data.forEach((row) => {
            // Si son calderas, renombra
            let nombre = row.nombre;
            if (table.key === "calderas") {
              if (row.nombre.toLowerCase().includes("1")) nombre = "Caldera eléctrica 11";
              if (row.nombre.toLowerCase().includes("2")) nombre = "Caldera eléctrica 12";
            }


            data.push([
              nombre,
              ...table.headers.map(hora => row.valores[hora] ?? "-")
            ]);

            if (row.nombre === 'Motor 4' || row.nombre === 'Motor 6') {
              const emptyRow = ["", ...table.headers.map(() => "")];
              data.push(emptyRow);
              estilosFilasBlancas.push(data.length - 1);
            }
          });

          startY = addTable(headers, data, startY, table.hideValues);
      });
      // Programa de motores y calderas 
        const tablaResumenProgramas = [];

        // Fila de Programa motores
        tablaResumenProgramas.push([
          "Programa motores",
          ...this.horasUnicas_horario_general.map(h =>
            this.datosTranspuestos_conceptos_motores_horario[0]?.valores[h]?.toFixed(2) ?? "0.00"
          )
        ]);

        // Fila de Programa calderas eléctricas
        tablaResumenProgramas.push([
          "Programa calderas eléctricas",
          ...this.horasUnicas_horario_general.map(h =>
            this.datosTranspuestos_conceptos_calderas_horario[0]?.valores[h]?.toFixed(2) ?? "0.00"
          )
        ]);

        startY = addTable(["", ...this.horasUnicas_horario_general], tablaResumenProgramas, startY);

      // Añadir la cifra de consumo total de gas en la parte inferior del PDF
      doc.setFontSize(14);
      //doc.text(`Consumo Total de Gas: ${this.items['total_consumo_gas']} MWh`, 14, startY + 10);

       // Ancho de página real y márgenes
      const pageWidth = doc.internal.pageSize.getWidth();
      const usableWidth = pageWidth - margin * 2;
      const col1Width = usableWidth * 0.25;
      const col2Width = usableWidth * 0.75;

      // Datos vacíos para 5 filas
      const actuacionesVacia = Array.from({ length: 7 }, () => ['', '']);

      // Título de la tabla "Actuaciones"
      doc.setFontSize(14);  
      doc.setTextColor(0);
      doc.text('Actuaciones', margin, startY + 2);

      
      doc.autoTable({
        startY: startY + 6, 
        body: actuacionesVacia,
        styles: {
          fontSize: 9,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          cellPadding: { top: 4, bottom: 4, left: 3, right: 3 },
          halign: 'left',
          valign: 'middle'
        },
        columnStyles: {
          0: { cellWidth: col1Width },
          1: { cellWidth: col2Width }
        },
        margin: { left: margin, right: margin },
        theme: 'grid',
        headStyles: {
          
          textColor: [255, 255, 255],
          lineWidth: 0.5,
          lineColor: [0, 0, 0]
        }
      });

      startY = doc.lastAutoTable.finalY + 10;


      // Guardar el PDF
      doc.save("tabla_prevision_operarios.pdf");
  },

async sendNom(){
    // Crear un objeto FormData para enviar el archivo ZIP
    const precios =this.items['total_consumo_gas']
    const data={
      "NOMINATION_VALUE":precios,
    }

    const zip = new JSZip();
    zip.file("data.json", JSON.stringify(data));

    // Generar el archivo ZIP en formato blob
    const zipBlob = await zip.generateAsync({ type: "blob" });

    // Crear un objeto FormData para enviar el archivo ZIP
    const formData = new FormData();
    formData.append("file", zipBlob, "data.zip");
    console.log("formData:  ", formData)
    await axios({
                method: "post",
                url: process.env.VUE_APP_API_BASE_URL + "/api/nominacion/",
                data: formData,
                withCredentials: true,
                headers: {
                  Authorization: "Bearer " + store.state.token,
                  //"Access-Control-Allow-Origin": "*",
                  //"Content-Type": "multipart/form-data",
                },
              });
},
formatearFechaConCeros(fechaTexto) {
  if (!fechaTexto) return "";

  const [dia, mes, anio] = String(fechaTexto).split("/");

  if (!dia || !mes || !anio) return fechaTexto;

  return `${String(dia).padStart(2, "0")}/${String(mes).padStart(2, "0")}/${anio}`;
},

formatearKwh(valorMwh) {
  if (valorMwh === "" || valorMwh == null) return "";

  const numeroMwh = Number(String(valorMwh).replace(",", "."));

  if (!Number.isFinite(numeroMwh)) return valorMwh;

  const valorKwh = numeroMwh * 1000;

  return valorKwh
    .toFixed(2)
    .replace(/\.?0+$/, "");
},
  async sendMailNom() {
  const destinatario = "<Iago.ibanez@cepsa.com>;<Jorge.meyer@cepsa.com>;<OPS-GasPower@cepsa.com>;<cgc_operaciones@cepsa.com>";
  //const destinatario = "<prueba.prueba@test.com>"; // destinatario de prueba
  const asunto = "Nominación Gas Viscofan";
  const copia = "martinro@viscofan.com;VilarB@viscofan.com;<perezmik@viscofan.com>";
  // const copia = "prueba.test@test.com"; //Copia de prueba
  const fechaFormateada = this.formatearFechaConCeros(this.fechaSimulacion);
  const total_consumo_gas=this.items["total_consumo_gas"]
  const qdNominadaKwh = this.formatearKwh(total_consumo_gas); //MWh que convertimos a KWh
  const qd=this.formatearKwh(this.parametrosGas['Qd']) //MWh pasados a KWh
  console.log(`QD ${qd}  qdNominadaKwh ${qdNominadaKwh}`);
  // alert(`QD ${qd}  qdNominadaKwh ${qdNominadaKwh}`)
  let extra_text
  //Revisar condicional, o valor por defecto de qd
  if (qdNominadaKwh>qd){
    // alert(`Dentro de if  ${qdNominadaKwh>qd}`)
    let diferencia_qd=qdNominadaKwh-qd //Ambos en KWh
    const redondeado_qd = Math.ceil(diferencia_qd / 10000) * 10000;
    // Por si acaso, si es negativo no poner texto
    if (redondeado_qd>=0){
      extra_text=`Adicionalmente, necesitamos contratar ${redondeado_qd} KWh de Qd diaria para mañana.`
    }else{
      extra_text=""
    }
  }
  else{
    extra_text=""
  }
  // Eencriptado de espacio en blanco
  const nbsp = "\u00A0";
  const cuerpo = `Buenas tardes,
  
  Os pasamos la nominación de gas para mañana:

  ──────────────────────
  Fecha${nbsp.repeat(10)}┃ Qd nominada (kWh)
  ${fechaFormateada} ┃ ${qdNominadaKwh}
  ──────────────────────
  ${extra_text}
  Gracias y Saludos,
  `;

  const asuntoCodificado = encodeURIComponent(asunto);
  const cuerpoCodificado = encodeURIComponent(cuerpo);
  const copiaCodificada = encodeURIComponent(copia);

  const mailtoLink = `mailto:${destinatario}?subject=${asuntoCodificado}&body=${cuerpoCodificado}&cc=${copiaCodificada}`;

  window.location.href = mailtoLink;
},


/*
Para planificación
<martinro@viscofan.com>; <VilarB@viscofan.com>; 
	<ARCAYG@viscofan.com>; <martinezie@viscofan.com>;
	<AlbuerneI@viscofan.com>; <MARTINEZR@viscofan.com>; <SanzP@viscofan.com>;
	Cogeneracion <cogeneracion@viscofan.com>;
	<IriarteD@viscofan.com>; <ArzaJ@viscofan.com>; <RazquinI@viscofan.com>; 
	<ZAPATAJ@viscofan.com>;  <MARTINO@viscofan.com>;
	 <fernandezj@viscofan.com>;  <ZUBIETAL@viscofan.com>; 
	<sanzf@viscofan.com>;  <AsinAn@viscofan.com>;  <AYAPEJ@viscofan.com>; 
	<ARMENDARIZN@viscofan.com>;  <GOGORZAI@viscofan.com>;
	<ALBERDIJ@viscofan.com>;  <catalanp@viscofan.com>; 
	<FERNANDEZE@viscofan.com>;  <garciajo@viscofan.com>;
	 <IturriA@viscofan.com>;  <lergaa@viscofan.com>; 
	<LOPEZAM@viscofan.com>;  <lopezin@viscofan.com>;
	 <MARINAP@viscofan.com>;  <MorionesC@viscofan.com>; 
	<PASCUALA@viscofan.com>; <PEJENAUTEF@viscofan.com>; <RUIZE@viscofan.com>;
	<crespor@viscofan.com>; <LONGASJ@viscofan.com>
*/
sendMailPlan(){
  // Obtener la fecha actual
    const diasSemana = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    const diaNombre = diasSemana[this.fecha.getDay()];
  const destinatario = `usr.mail.vfes.energy_planning@viscofan.com`;
  //Asunto en formato "Planificación miercoles 07/05/2025"
    const asunto = `Planificación  ${diaNombre} ${this.fechaSimulacion}`;
    //const copia = "martinro@viscofan.com;VilarB@viscofan.com"; 

    const cuerpo = `Buenas tardes,
    
    Adjunto planificación del día ${this.fechaSimulacion}.

    Un saludo,
    `;
    const asuntoCodificado = encodeURIComponent(asunto);
    let cuerpoCodificado = encodeURIComponent(cuerpo);
    //console.log("destinatario ", destinatario)
    //console.log("Codificado asunto ", asuntoCodificado)
    //let copiaCodificada = encodeURIComponent(copia); 
    //console.log("Codificado cuerpo ", cuerpoCodificado)
    // Crear la URL mailto
    const mailtoLink = `mailto:${destinatario}?subject=${asuntoCodificado}&body=${cuerpoCodificado}`;
    //console.log("mail: ", mailtoLink)

    // Abrir el cliente de correo del usuario
    window.location.href = mailtoLink;
},


async exportToExcel() {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Previsión Operarios");

  const azulClaro = "FF9BC2E6";

  const bordeCompleto = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" }
  };

  const aplicarFormatoNumero = (cell, unidad = "") => {
  if (typeof cell.value !== "number") return;

  const tieneDecimales = !Number.isInteger(cell.value);

  const formatoBase = tieneDecimales
    ? '#,##0.##'
    : '#,##0';

  cell.numFmt = unidad
    ? `${formatoBase} "${unidad}"`
    : formatoBase;
};

  const agregarTabla = (datos, headers, opciones = {}) => {
    const {
      renombrar,
      colorPorValor,
      blankAfter,
      bordeCompletoEnTodas
    } = opciones;

    sheet.addRow([]);

    const filaHeader = sheet.addRow(["", ...headers]);
    filaHeader.font = { bold: true };

    filaHeader.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    datos.forEach((row) => {
      const nombre = renombrar ? renombrar(row.nombre) : row.nombre;
      const filaValores = [nombre];

      headers.forEach((hora) => {
        const valor = row.valores[hora];

        if (colorPorValor) {
          filaValores.push("");
        } else {
          const valorNumerico = this.normalizarNumeroExcel(valor, 2);
          filaValores.push(valorNumerico !== "" ? valorNumerico : (valor ?? "-"));
        }
      });

      const fila = sheet.addRow(filaValores);

      fila.eachCell((cell, colNumber) => {
        if (
          colorPorValor &&
          colNumber > 1 &&
          row.valores[headers[colNumber - 2]]
        ) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: azulClaro }
          };
        }

        if (bordeCompletoEnTodas || colNumber === 1) {
          cell.border = bordeCompleto;
        }

        if (colNumber > 1) {
          aplicarFormatoNumero(cell);
        }

        cell.alignment = { vertical: "middle", horizontal: "center" };
      });

      if (blankAfter && (row.nombre === "Motor 4" || row.nombre === "Motor 6")) {
        const filaBlanca = sheet.addRow(["", ...headers.map(() => "")]);

        filaBlanca.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.border = bordeCompleto;
          }
        });
      }
    });
  };

  // Siempre incluir motores
  agregarTabla(this.datosTranspuestos_motores, this.horasUnicas_motores, {
    colorPorValor: true,
    blankAfter: true,
    bordeCompletoEnTodas: false
  });

  // Siempre incluir calderas
  agregarTabla(this.datosTranspuestos_calderas, this.horasUnicas_calderas, {
    colorPorValor: true,
    renombrar: (nombre) => {
      if (nombre.toLowerCase().includes("1")) return "Caldera eléctrica 11";
      if (nombre.toLowerCase().includes("2")) return "Caldera eléctrica 12";
      return nombre;
    },
    bordeCompletoEnTodas: false
  });

  // Solo si NO es vista operador, incluir más tablas
  if (!this.vista_operador) {
    // Conceptos
    agregarTabla(this.datosTranspuestos_conceptos, this.horasUnicas_conceptos, {
      bordeCompletoEnTodas: true
    });

    // Programa horario general
    agregarTabla(
      [
        ...this.datosTranspuestos_conceptos_motores_horario,
        ...this.datosTranspuestos_conceptos_calderas_horario
      ],
      this.horasUnicas_horario_general,
      {
        bordeCompletoEnTodas: true
      }
    );
  }

  if (!this.esPlanificacion) {
    agregarTabla(this.datosTranspuestos_programa_qh, this.horasUnicas_programa_qh, {
      bordeCompletoEnTodas: true
    });
  }

  // Solo si NO es vista operador, añadir consumo y precio pool al final
  if (!this.vista_operador) {
    sheet.addRow([]);

    const totalGas = this.normalizarNumeroExcel(this.items.total_consumo_gas, 2);

    const filaTotal = sheet.addRow([
      "Consumo Total de Gas:",
      totalGas !== "" ? totalGas : "-"
    ]);

    filaTotal.font = { bold: true };
    filaTotal.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    filaTotal.getCell(2).alignment = { vertical: "middle", horizontal: "center" };
    aplicarFormatoNumero(filaTotal.getCell(2), "MWh");

    const precioPool = this.precioPoolRef != null
      ? this.normalizarNumeroExcel(this.precioPoolRef, 2)
      : "";

    const filaPrecioPool = sheet.addRow([
      "Precio pool referencia motores de cogeneración:",
      precioPool !== "" ? precioPool : "-"
    ]);

    filaPrecioPool.font = { bold: true };
    filaPrecioPool.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    filaPrecioPool.getCell(2).alignment = { vertical: "middle", horizontal: "center" };
    aplicarFormatoNumero(filaPrecioPool.getCell(2), "EUR/MWh");

    const precioPoolCe = this.precioPoolRefCe != null
      ? this.normalizarNumeroExcel(this.precioPoolRefCe, 2)
      : "";

    const filaPrecioPoolCe = sheet.addRow([
      "Precio pool referencia calderas eléctricas:",
      precioPoolCe !== "" ? precioPoolCe : "-"
    ]);

    filaPrecioPoolCe.font = { bold: true };
    filaPrecioPoolCe.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    filaPrecioPoolCe.getCell(2).alignment = { vertical: "middle", horizontal: "center" };
    aplicarFormatoNumero(filaPrecioPoolCe.getCell(2), "EUR/MWh");
  }

  // Ajuste de columnas
  sheet.columns.forEach((col) => {
    col.width = 12;
  });

  sheet.getColumn(1).width = 25;
  sheet.getColumn(2).width = 18;

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Prevision_Operarios.xlsx");
}
},
async mounted(){
      // 1. Separar la fecha
      const [dia, mes, anio] = this.fechaActual.split('/').map(Number); // convierte a números
      // 2. Crear el objeto Date (mes - 1 porque los meses en JS son 0-based)
      const fecha = new Date(anio, mes - 1, dia);
      // 3. Sumar un día
      fecha.setDate(fecha.getDate() + 1);
      // 4. Obtener el nuevo día, mes y año
      const nuevoDia = fecha.getDate();
      const nuevoMes = fecha.getMonth() + 1; // mes 0-based
      const nuevoAnio = fecha.getFullYear();
      this.fecha=fecha
      // 5. Formatear como "d/m/y"
      this.fechaSimulacion = `${nuevoDia}/${nuevoMes}/${nuevoAnio}`|| "fecha desconocida";

      
  
}

}

</script>

<style>
.motor, .caldera{
 height: 18px !important;
  font-size: 8px;
  width: 140px !important;
  vertical-align: middle;
}

.v-table.row-height-50 td {
  height: 18px !important;
  font-size: 8px;
  text-align: center;
  vertical-align: middle;
}

.v-table.row-height-50 th {
  height: 18px !important;
  font-size: 8px;
  text-align: center;
  vertical-align: middle;
}

.red-cell {
  background-color: red;
  color: white;
}

.green-cell {
  background-color: green;
  color: white;
}

.box {
  margin: 20px;
  padding: 10px;
}

.columna-fija {
  width: 140px !important;
  min-width: 140px !important;
  max-width: 140px !important;
  text-align: center;
  vertical-align: middle;
}

.hora-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  text-align: center;
  font-size: 8px;
  vertical-align: middle;
}
.H{
  vertical-align: middle;
  text-align: center;
}
.v-table th {
  text-align: center !important;
  vertical-align: middle !important;
}

/* --- Botonera de ComponentePrograma*/
@media (max-width: 1366px) {
  /* La fila de botones debe poder partir en varias líneas */
  .v-col.d-flex.justify-start {
    flex-wrap: wrap !important;
    gap: 8px;                 /* separación uniforme entre botones */
  }
  /* Botones u más compactos */
  .v-col.d-flex.justify-start .v-btn {
    min-width: 40px;
    padding: 0 10px;
    font-size: 12px;
  }
}

/* En pantallas ≤1024px convertimos los botones a "icon-only" automáticamente */
@media (max-width: 1024px) {
  /* Ocultar el texto del botón, mantener el icono */
  .v-col.d-flex.justify-start .v-btn .v-btn__content {
    font-size: 0;               /* oculta el texto */
  }
  .v-col.d-flex.justify-start .v-btn .v-btn__content .v-icon {
    font-size: 20px;    
  }
 
  .v-col.d-flex.justify-start .v-btn {
    margin: 0;
  }
}
</style>
